import styled from 'styled-components';
export var Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-u2cuw1-0"
})(["display:flex;flex-direction:column;flex-grow:1;height:100%;padding:16px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.colors.primary);
});